import { CompositeServiceData } from 'chaika-frontend-types/frontend-cms';

import { store } from '@store';
import { serviceService } from '@services/services/serviceService';
import { PriceApi } from '@api/PriceApi';

class PriceListService {
    public async loadCompositeServices(): Promise<void> {
        const priceListStore = store.priceListStore;

        if (!priceListStore.compositeServiceList.isDataSet) {
            const { prices } = await PriceApi.getCompositeServices();
            await this.loadServices(prices);

            priceListStore.compositeServiceList.set(prices);
        }
    }

    private async loadServices(compositeServices: CompositeServiceData[]): Promise<void> {
        const ids = compositeServices.reduce<string[]>((ids, { serviceId, includedServices }) => {
            ids.push(serviceId, ...includedServices);
            return ids;
        }, []);

        await serviceService.loadByIds(ids);
    }
}

export const priceListService = new PriceListService();
